module.exports = __webpack_public_path__ + "static/media/replay_i.f6b45f66.svg";